// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"3eb41c0e","450":"b3cbf35e"}[chunkId] + ".chunk.js";
};